module.exports = __webpack_public_path__ + "img/160.ed67098e.jpg";